import { CollectionProduct } from 'api/shopifyV2/types';
import { getIdFromShopifyFormattedId } from 'shared/utils/shopify/ids';
import { SubscriptionLineItemV2 } from '../getSubscriptionDetails/types';

export const convertCollectionProductToLineItem = (
  product: CollectionProduct,
  quantity: number
): SubscriptionLineItemV2 => {
  const parsedShopifyContractId = getIdFromShopifyFormattedId(product.id ?? '');
  const shopifyContractIdInt = parseInt(parsedShopifyContractId!, 10) || 0;

  return {
    discount_amount: 0,
    is_one_time: false,
    product: {
      amount: parseInt(product.variants[0].price.amount, 10),
      image_url: product.featuredImage?.src || '',
      metafields: product.metafields,
      name: product.title,
      shopify_variant_id: product.variants[0].id,
      shopify_variant_title: product.variants[0].title
    },
    quantity,
    shopify_contract_id: product.id,
    total_amount: parseInt(product.variants[0].price.amount, 10),
    in_stock: true,
    id: shopifyContractIdInt,
    shopify_line_item_id: ''
  };
};

export const getFallbackProduct = (result: any, productId: string) => {
  return result.line_items.find((item: any) => item.product.shopify_variant_id === productId) || {};
};
